import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PasswordResetToken, PasswordResetTokenCreate, PasswordResetTokenFilter } from '../data/passwordResetToken';

export function createPasswordResetTokenService(client: AxiosInstance) {
  return createCrudService<PasswordResetToken, PasswordResetTokenCreate, PasswordResetTokenFilter>(
    client,
    '/identity/PasswordResetToken',
    'id',
  );
}

export type PasswordResetTokenService = CrudService<PasswordResetToken, PasswordResetTokenCreate, PasswordResetTokenFilter>;
